import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=38fa41bd"
import script from "./PaymentInvoice.vue?vue&type=script&lang=js"
export * from "./PaymentInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports